/* eslint-disable */
/* tslint:disable */
import PropTypes from 'prop-types';
import React from 'react';
import Share from 'wix-ui-icons-common/on-stage/Share';
var share_store = function (_a) { return (React.createElement(Share, { size: "24" })); };
share_store.displayName = 'share_store';
share_store.propTypes = {
    size: PropTypes.string
};
export default share_store;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=share_store.js.map